const API_BASE = import.meta.env.VITE_API_URL || 'https://api.cellysheets.ca/api';

const handleResponse = async (response: Response) => {
  if (response.status === 401) {
    window.dispatchEvent(new Event('auth:unauthorized'));
  }
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'API Request Failed');
  }
  return response.json();
};

export const documentService = {
  async getDocuments(token: string, params?: { workspaceId?: string, type?: 'personal' | 'team' }) {
    const query = params 
      ? `?${new URLSearchParams(params as any).toString()}` 
      : '';
      
    const response = await fetch(`${API_BASE}/documents${query}`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
  },

  async createDocument(token: string, workspaceId?: string, title?: string) {
    const response = await fetch(`${API_BASE}/documents`, {
      method: 'POST',
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' 
      },
      body: JSON.stringify({ workspaceId, title }),
    });
    return handleResponse(response);
  },

  async deleteDocument(token: string, id: string) {
    const response = await fetch(`${API_BASE}/documents/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
  },

  async getAccess(token: string, id: string) {
    const response = await fetch(`${API_BASE}/documents/${id}/access`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
  },

  async getShareSettings(token: string, id: string) {
    const response = await fetch(`${API_BASE}/documents/${id}/share`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
  },

  async updateShareSettings(token: string, id: string, isPublic: boolean, publicRole: string) {
    const response = await fetch(`${API_BASE}/documents/${id}/share`, {
      method: 'PATCH',
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' 
      },
      body: JSON.stringify({ isPublic, publicRole }),
    });
    return handleResponse(response);
  },

  async addCollaborator(token: string, documentId: string, email: string, role: string) {
    const response = await fetch(`${API_BASE}/documents/${documentId}/collaborators`, {
        method: 'POST',
        headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' 
        },
        body: JSON.stringify({ email, role }),
    });
    return handleResponse(response);
  },

  async removeCollaborator(token: string, documentId: string, userId: string) {
    const response = await fetch(`${API_BASE}/documents/${documentId}/collaborators/${userId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return handleResponse(response);
  }
};